module.exports = __webpack_public_path__ + "static/img/6.3f76a4a9.png";